module.exports = __webpack_public_path__ + "img/icon-02.df4c483d.png";